<div class="card h-full p-3 flex flex-col gap-3 mt-2">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <div class="flex flex-row justify-between items-center py-3">
      <div class="title flex flex-grow-0 justify-start">Bank Account</div>
      <div class="flex flex-grow justify-end">
        <button
          class="btn btn-primary text-white"
          (click)="openAddRek(content)"
          [disabled]="addDisable"
        >
          Add Account
        </button>
      </div>
    </div>
    <div class="divider"></div>
  </nz-skeleton>

  <div
    *ngIf="bankList === null || bankList.length === 0"
    class="flex flex-col justify-center items-center"
  >
    <nz-skeleton
      *ngIf="loading"
      [nzLoading]="loading"
      [nzActive]="true"
    ></nz-skeleton>
    <img
      *ngIf="!loading"
      class="mt-4"
      src="https://storage.googleapis.com/komerce/assets/illustration/BG-Rekening-Bank.svg"
      alt=""
      width="50%"
    />
    <h2 *ngIf="!loading" class="mt-4">No Bank Account Saved Yet</h2>
    <p *ngIf="!loading">
      Come on, add your bank account to make it easier to withdraw your Kompay
      balance.
    </p>
  </div>

  <div *ngIf="bankList !== null && bankList.length > 0">
    <div *ngFor="let item of bankList; let i = index">
      <app-rekening-item
        [item]="item"
        [loading]="loading"
        [bankNameList]="bankNameList"
        (onEdit)="onStartEdit(item)"
        (onCancel)="cancelEdit(item)"
        (onSave)="editBank($event)"
      ></app-rekening-item>
    </div>
  </div>
</div>

<ng-template #content let-offcanvas>
  <app-rekening-form
    [bankNameList]="bankNameList"
    (onClose)="closeAddRek(content)"
    (onSave)="addRekening($event, content)"
  ></app-rekening-form>
</ng-template>
